import { SVGProps } from "react"


function HouseFallbackSVG(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      aria-label="ikon hus"
      viewBox="0 0 166.96 164.4"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="h-full w-full"
      {...props}
    >
      <mask
        id="a"
        height="106.29"
        maskUnits="userSpaceOnUse"
        width="125.75"
        x="41.2"
        y="58.11"
      >
        <path
          d="m41.2 58.11h125.8v86.76h-125.8z"
          fill="#fff"
          fillRule="evenodd"
        />
      </mask>
      <mask
        id="b"
        height="66.22"
        maskUnits="userSpaceOnUse"
        width="47.56"
        x="57.48"
        y="88.59"
      >
        <path
          d="m57.48 88.6h47.52v56.27h-47.52z"
          fill="#fff"
          fillRule="evenodd"
        />
      </mask>
      <path
        d="m54.39 17c-.45-4 11.27-7.17 22.35-8.4s23.19-.73 23.64 3.28l-1.75.2c-.15-1.39-7.95-3.26-21.7-1.73s-21 5.07-20.8 6.46z"
        fill="#ffaf84"
        fillRule="evenodd"
      />
      <path
        d="m55.4 22.38a5.5 5.5 0 1 1 0-7.78 5.51 5.51 0 0 1 0 7.78zm-4.57-22.38-15.47 4.58-35.36 35.48 30.12 29.94 35.36-35.48 4.52-15.47z"
        fill="#ff620f"
        fillRule="evenodd"
      />
      <path
        d="m99.52 3.62-17.22-3.02-9.8 55.86 17.22 3z"
        fill="#91c5f0"
        fillRule="evenodd"
      />
      <path
        d="m121.85 9.94-65.41 48.17 1.61 5.22 106.79 18.67 2.16-4.5z"
        fill="#0d426e"
        fillRule="evenodd"
      />
      <g mask="url(#a)">
        <path
          d="m56.45 58.11-15.25 86.89 110.51 19.4 15.29-86.9z"
          fill="#238ce2"
          fillRule="evenodd"
        />
      </g>
      <g mask="url(#b)">
        <path
          d="m89.66 89.4-3-.52a18.58 18.58 0 0 0 -21.48 15.12l-7.7 43.9 39.58 6.94 7.7-43.9a18.59 18.59 0 0 0 -15.1-21.54"
          fill="#91c5f0"
          fillRule="evenodd"
        />
      </g>
      <g fillRule="evenodd">
        <path
          d="m77.05 124a4.51 4.51 0 1 1 -3.66-5.22 4.51 4.51 0 0 1 3.66 5.22"
          fill="#0d426e"
        />
        <path
          d="m54.38 17.13 1.74-.19c.16 1.39 7.95 3.26 21.7 1.73s21-5.07 20.8-6.46l1.74-.2c.45 4-11.27 7.18-22.34 8.41a92.94 92.94 0 0 1 -10.13.58c-7.29 0-13.21-1.08-13.51-3.87z"
          fill="#ffaf84"
        />
        <path
          d="m116.21 104.38 3.72-20.67 13 2.33-3.72 20.67z"
          fill="#0d426e"
        />
        <path
          d="m111.14 132.59 3.72-20.66 13 2.33-3.72 20.67z"
          fill="#0d426e"
        />
        <path
          d="m137.31 108.17 3.69-20.67 13 2.33-3.71 20.67z"
          fill="#0d426e"
        />
        <path
          d="m132.19 136.63 3.71-20.63 13 2.34-3.74 20.66z"
          fill="#0d426e"
        />
      </g>
    </svg>
  )
}

export default HouseFallbackSVG
